/**
 * Глобальный модал «Пополните баланс». Срабатывает когда любой backend-
 * запрос (chat, generate, ...) возвращает ошибку insufficient_funds.
 * Сидит в AppLayout, читает state из useTopUp.
 */
import { useNavigate } from "react-router-dom";
import { Coins } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/Dialog";
import { Button } from "@/components/ui/Button";
import { useTopUp } from "@/stores/topup";
import { useAuth } from "@/stores/auth";
import { useAuthDialog } from "@/stores/authDialog";

export function TopUpModal() {
  const open = useTopUp((s) => s.open);
  const setOpen = useTopUp((s) => s.setOpen);
  const navigate = useNavigate();
  const isGuest = !!useAuth((s) => s.user)?.is_guest;
  const openAuthDialog = useAuthDialog((s) => s.openDialog);

  // Гость: пополнение недоступно — вместо него предлагаем зарегистрироваться.
  if (isGuest) {
    return (
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <div className="grid h-12 w-12 place-items-center rounded-2xl bg-brand-50 text-brand-700 mb-3">
            <Coins className="h-6 w-6" />
          </div>
          <DialogTitle>Бесплатные кредиты закончились</DialogTitle>
          <DialogDescription>
            Вы вошли как гость. Создайте аккаунт, чтобы получить стартовый бонус и пополнять баланс
          </DialogDescription>
          <div className="mt-5 flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
            <Button variant="ghost" onClick={() => setOpen(false)}>Позже</Button>
            <Button onClick={() => { setOpen(false); openAuthDialog("signup"); }}>
              Создать аккаунт
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md">
        <div className="grid h-12 w-12 place-items-center rounded-2xl bg-brand-50 text-brand-700 mb-3">
          <Coins className="h-6 w-6" />
        </div>
        <DialogTitle>Закончились кредиты</DialogTitle>
        <DialogDescription>
          Чтобы продолжить пользоваться моделями, пополните баланс или активируйте промокод
        </DialogDescription>
        <div className="mt-5 flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
          <Button variant="ghost" onClick={() => setOpen(false)}>Позже</Button>
          <Button onClick={() => { setOpen(false); navigate("/billing"); }}>
            Перейти к пополнению
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
